import ImageResize from './Converter component/ImageResize';
import Converterhomepage from './Converterhomepage.js';
import JpegToPdf from './Converter component/JpegToPdf';
import Pdgtojpeg from './Converter component/Pdgtojpeg';
import Pdftoword from './Converter component/Pdftoword.js' 
import Pdftoexcel from './Converter component/Pdftoexcel.js'

import './Converter.css';
import { Link, Route, Routes } from 'react-router-dom'; 
import Pdftopowerpoint from './Converter component/Pdftopowerpoint.js';
let Converter=()=>{
    return(
        <div className='convertermaincont'> 
            <div className='linkdivcont'>
                <span className='pdflinkcont ssmm'>
                    <Link  className='pdflink' to='./'>Home</Link>
                </span>
                <span className='pdflinkcont ssmm'>Pdf Converter
                    <div className='hoveredlinkcont'>  
                        <Link className='pdflink' to='pdftojpegconvert'>Convert PDF to JPG</Link>
                        <Link className='pdflink' to='pdftoword'>Convert PDF to Word</Link>
                        <Link className='pdflink' to='pfgtopowerpoint'>Cnv... PDF to Powerpoint</Link>
                        <Link className='pdflink' to='pdftoexcel'>Pdof to Excel</Link> 
                        
                         
                        

                    </div>
                
                </span>
                <span className='imagelinkk ssmm'>Image Converter
                    
                    <div className='hoveredlinkcont'>  
                        <Link className='pdflink' to='ImageResizer'>Image Resizer</Link>
                        <Link className='pdflink' to='jpegtopdf'>Convert Image to Pdf</Link>
                        
                        

                    </div>
                    
                    
                </span> 
                
            </div> 
            
            <Routes>
                <Route path='/' element={<Converterhomepage/>}/>
                <Route path="pdftojpegconvert" element={<Pdgtojpeg/>}/>
                <Route path='jpegtopdf' element={<JpegToPdf/>}/>
                <Route path='pdftoword' element={<Pdftoword/>}/>
                <Route path='pdftoexcel' element={<Pdftoexcel/>}/>
                <Route path='pfgtopowerpoint' element={<Pdftopowerpoint/>}/>

                <Route path='ImageResizer' element={<ImageResize/>}/>
            </Routes> 


 
            
        </div>
    ); 
}
export default Converter;